import dayjs from 'dayjs';
import { useScheduleBoardContext } from 'pos-client/components/scheduleBoard/context/ScheduleBoardContext.tsx';

export const useSelectedLocationTimeZoneOffset = () => {
  const { selectedDate, selectedLocation } = useScheduleBoardContext();

  const timeZoneOffset = dayjs
    // pass the selected current date to .tz in order to account for daylight savings
    .tz(selectedDate, selectedLocation?.address?.timeZone ?? '')
    .format('ZZ');

  return { timeZoneOffset };
};
